import * as React from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { Box, Typography, Button } from '@mui/material'
import { EdGateStandardsResp } from './types'
import { edgateStandardsAtom, edgateSubjectAtom } from './atoms'
import { downloadFile, openInNewTab } from 'shared/utils/fileExport'

interface EdgateStandardsViewProps {
  state: string
}

const downloadJson = (
  data: EdGateStandardsResp['data'],
  state: string,
  subject: string,
) => {
  const fileName = `edgate_${state.replace(/\s+/g, '_')}_${subject.replace(/\s+/g, '_')}.json`
  downloadFile({
    fileName,
    fileDataString: JSON.stringify(data, null, 2),
    fileDataType: 'data:text/json;charset=utf-8',
  })
}

export const EdgateStandardsView: React.FC<EdgateStandardsViewProps> = ({
  state,
}) => {
  const [edgateStandards] = useAtom(edgateStandardsAtom)
  const [edgateSubject] = useAtom(edgateSubjectAtom)

  const count = Object.keys(edgateStandards?.data || {}).length

  const handleDownload = () => {
    if (edgateStandards?.data && edgateSubject) {
      downloadJson(edgateStandards.data, state, edgateSubject)
    }
  }

  const handleOpen = () => {
    if (edgateStandards?.data && edgateSubject) {
      openInNewTab({ data: edgateStandards.data })
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="body2" color="text.secondary">
        State: {state}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Subject: {edgateSubject || 'N/A'}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Number of standards: {count}
      </Typography>
      <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
        <Button
          variant="text"
          size="small"
          onClick={handleOpen}
          disabled={!edgateStandards?.data || !edgateSubject}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          Open JSON
        </Button>
        <Button
          variant="text"
          size="small"
          onClick={handleDownload}
          disabled={!edgateStandards?.data || !edgateSubject}
          sx={{ textTransform: 'none', fontSize: '0.75rem' }}
        >
          Download JSON
        </Button>
      </Box>
    </Box>
  )
}
